import { useEffect, useState } from "react";
import { Loader2, Inbox, Check, X, Clock } from "lucide-react";
import { api } from "@/lib/api";
import { BUREAU_COLORS } from "@/lib/brand";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function RequestsInbox() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/dispute-requests").then(({ data }) => setItems(data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const approve = async (id) => { await api.post(`/dispute-requests/${id}/approve`); toast.success("Approved — dispute created"); load(); };
  const decline = async (id) => { await api.post(`/dispute-requests/${id}/decline`); toast.success("Declined"); load(); };

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="h-7 w-7 animate-spin text-[#C1121F]" /></div>;

  return (
    <div className="space-y-4" data-testid="requests-panel">
      {items.length === 0 ? (
        <div className="text-center py-20 text-neutral-400"><Inbox className="h-10 w-10 mx-auto opacity-40 mb-3" />No client requests yet.</div>
      ) : items.map((r) => {
        const bc = BUREAU_COLORS[r.bureau] || BUREAU_COLORS.Furnisher;
        const pending = r.status === "Pending Review";
        return (
          <div key={r.id} className="rounded-2xl border border-neutral-200 bg-[#FFFFFF]/80 p-5 flex flex-wrap items-center justify-between gap-4" data-testid="request-row">
            <div className="min-w-0">
              <div className="font-semibold">{r.consumerName} · <span className="font-normal text-neutral-500">{r.creditor || "Dispute request"}</span></div>
              <div className="text-xs text-neutral-400 flex flex-wrap items-center gap-2 mt-1">
                <span className={`px-2 py-0.5 rounded-md border ${bc.chip} ${bc.text} ${bc.border}`}>{r.bureau}</span>
                {r.accountNumber && <span className="font-mono">{r.accountNumber}</span>}
                {r.amount && <span className="font-mono text-[#9B0E18]">{r.amount}</span>}
              </div>
              {r.reason && <p className="mt-2 text-sm text-neutral-500 max-w-2xl">{r.reason}</p>}
            </div>
            {pending ? (
              <div className="flex gap-2">
                <Button onClick={() => approve(r.id)} className="rounded-full bg-[#15803D] hover:bg-[#1E9E4B] text-white font-semibold" data-testid="request-approve-button"><Check className="h-4 w-4 mr-1.5" /> Approve</Button>
                <Button onClick={() => decline(r.id)} variant="outline" className="rounded-full border-neutral-200 bg-neutral-50 hover:bg-neutral-200" data-testid="request-decline-button"><X className="h-4 w-4 mr-1.5" /> Decline</Button>
              </div>
            ) : (
              <span className={`text-xs px-2.5 py-1 rounded-md border flex items-center gap-1 ${r.status === "Approved" ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-stone-100 text-stone-600 border-stone-300"}`}>
                <Clock className="h-3 w-3" />{r.status}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
